import { CONTAINS, IS_NOT_TEXT, IS_TEXT, NOT_CONTAINS, STARTS_WITH } from '../filter-conditions.js';
export const nameFilterConditions = [
    IS_TEXT,
    IS_NOT_TEXT,
    CONTAINS,
    NOT_CONTAINS,
    STARTS_WITH,
];
//# sourceMappingURL=filters.js.map